export default __webpack_public_path__ + "925f38d02ce3487a3b2eff4ea23ed341.png";